
import {combineLatest as observableCombineLatest,  BehaviorSubject, Observable, ReplaySubject } from 'rxjs';

import {map, filter} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AnimatedButtonState } from '@shared/components/animated-button/animated-button-state';
import { IErrorInfo } from '@shared/components/modal-form-host/error-info';
import { ModalActionStatus } from '@shared/components/modal-form-host/modal-action-status';

export interface IFormHostState {
    form: NgForm;
    status: ModalActionStatus;
    error: IErrorInfo;
    animatedButtonState: AnimatedButtonState;
    hide$: Observable<boolean>;
    clear();
    destroy();
}

export class FormHostState implements IFormHostState {
    constructor(name: string) {
        this.name = name;
    }

    private destroyed$ = new ReplaySubject<boolean>(1);

    get name(): string { return this.name$.value; }
    set name(value: string) { this.name$.next(value); }
    public name$: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);

    get form(): NgForm { return this.form$.value; }
    set form(value: NgForm) { this.form$.next(value); }
    public form$ = new BehaviorSubject<NgForm>(null);

    get status(): ModalActionStatus { return this.status$.value; }
    set status(value: ModalActionStatus) { this.status$.next(value); }
    public status$ = new BehaviorSubject<ModalActionStatus>(ModalActionStatus.Iddle);

    get error(): IErrorInfo { return this.error$.value; }
    set error(value: IErrorInfo) { this.error$.next(value); }
    public error$ = new BehaviorSubject<IErrorInfo>(null);

    get animatedButtonState(): AnimatedButtonState { return this.animatedButtonState$.value; }
    set animatedButtonState(value: AnimatedButtonState) { this.animatedButtonState$.next(value); }
    public animatedButtonState$ = new BehaviorSubject<AnimatedButtonState>(AnimatedButtonState.Default);

    public hide$ =
        observableCombineLatest(this.status$, this.animatedButtonState$).pipe(
            filter(([status, animated]) => !!status && !!animated),
            map(([status, animated]) => status === ModalActionStatus.Finished && animated === AnimatedButtonState.Default),);

    public clear() {
        this.form = null;
        this.status = ModalActionStatus.Iddle;
        this.animatedButtonState = AnimatedButtonState.Default;
        this.error = null;
    }

    public destroy() {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}

export interface IFormHostStateIndexer {
    [name: string]: IFormHostState;
}

@Injectable()
export class ModalFormHostStateService {

    public states: IFormHostStateIndexer = { };

    public form$ = new BehaviorSubject<NgForm>(null);
    get form(): NgForm { return this.form$.value; }
    set form(value: NgForm) { this.form$.next(value); }

    public status$ = new BehaviorSubject<ModalActionStatus>(ModalActionStatus.Iddle);
    get status(): ModalActionStatus { return this.status$.value; }
    set status(value: ModalActionStatus) { this.status$.next(value); }

    public error$ = new BehaviorSubject<IErrorInfo>(null);
    get error(): IErrorInfo { return this.error$.value; }
    set error(value: IErrorInfo) { this.error$.next(value); }

    public animatedButtonState$ = new BehaviorSubject<AnimatedButtonState>(AnimatedButtonState.Default);
    get animatedButtonState(): AnimatedButtonState { return this.animatedButtonState$.value; }
    set animatedButtonState(value: AnimatedButtonState) { this.animatedButtonState$.next(value); }

    public hide$ =
        observableCombineLatest(this.status$, this.animatedButtonState$).pipe(
            filter(([status, animated]) => !!status && !!animated),
            map(([status, animated]) => status === ModalActionStatus.Finished && animated === AnimatedButtonState.Default),);

    public clear() {
        this.form = null;
        this.status = ModalActionStatus.Iddle;
        this.animatedButtonState = AnimatedButtonState.Default;
        this.error = null;
    }
}
